import { render, staticRenderFns } from "./MessagesControl.vue?vue&type=template&id=476fe2cf"
import script from "./MessagesControl.vue?vue&type=script&lang=js"
export * from "./MessagesControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports